import { css, cx } from "@emotion/css";
import React from "react";

export function Desc({ desc, withTitle }: { desc: string; withTitle?: boolean }) {
  return (
    <div>
      {desc
        .trim()
        .split("\n")
        .map((s, i) => (
          <p
            className={cx(
              css`
                text-indent: 2.8rem;
                font-size: 1.2rem;
              `,
              withTitle && i == 0
                ? css`
                    font-size: 1.8rem;
                    letter-spacing: 0.1rem;
                    padding-bottom: 1rem;
                  `
                : null
            )}
          >
            {s}
          </p>
        ))}
    </div>
  );
}
